<template>
<div>
  <div class="row g-mb-20">
    <p class="g-mb-30 text-center g-font-size-18--md g-font-size-18 g-px-20">Changing Life through Lenses&reg; offers a few options to best accommodate how you engage in charity vision services. Select the account you would like to register for:</p>
    <!-- Individual Div -->
    <article class="col-md-4 g-mb-20  text-center" v-on:click="ChooseFormType('Individual')" v-bind:data-balloon="invAccountTooltip" data-balloon-pos="up" data-balloon-length="large">
      <div class="g-mb-15">
        <img class="img-fluid registration-icon" :src="individualIcon" alt="Individual Eye Doctor Account" v-on:mouseover="HoverIndividual('enter')" v-on:mouseleave="HoverIndividual('leave')">
      </div>
      <div class="g-mb-15">
        <h4 class="mb-3">Individual Eye Doctor</h4>
      </div>
      <a v-on:click="ChooseFormType('Individual')" v-on:mouseover="HoverIndividual('enter')" v-on:mouseleave="HoverIndividual('leave')" class="btn u-shadow-v39 g-color-white g-color-white--hover g-bg-main g-bg-primary--hover g-font-size-18--md g-font-size-17 g-rounded-30 g-px-35 g-py-8">Sign Up</a>
    </article>
    <!-- END Individual Div -->

    <!-- Business Div -->
    <article class="col-md-4 g-mb-30 text-center" v-on:click="ChooseFormType('Business')" v-bind:data-balloon="businessAccountTooltip" data-balloon-pos="up" data-balloon-length="large">
      <div class="g-mb-15">
        <img class="img-fluid registration-icon" :src="practiceIcon" alt="Practice/Business Account" v-on:mouseover="HoverPractice('enter')" v-on:mouseleave="HoverPractice('leave')">
      </div>
      <div class="g-mb-15">
        <h4 class="mb-3">Practice/Business</h4>
      </div>
      <a v-on:click="ChooseFormType('Business')" v-on:mouseover="HoverPractice('enter')" v-on:mouseleave="HoverPractice('leave')" class="btn u-shadow-v39 g-color-white g-color-white--hover g-bg-main g-bg-primary--hover g-font-size-18--md g-font-size-17 g-rounded-30 g-px-35 g-py-8">Sign Up</a>
    </article>
    <!-- End Business Div -->

    <!-- Non-Profit Div -->
    <article class="col-md-4 g-mb-30 text-center" v-on:click="ChooseFormType('NonProfit')" v-bind:data-balloon="nonprofitAccountTooltip"
      data-balloon-pos="up" data-balloon-length="large">
      <div class="g-mb-15">
        <img class="img-fluid registration-icon" :src="nonProfitIcon" alt="Non-Profit Account" v-on:mouseover="HoverNonProfit('enter')" v-on:mouseleave="HoverNonProfit('leave')">
      </div>
      <div class="g-mb-15">
        <h4 class="mb-3">Non-Profit</h4>
      </div>
      <a  v-on:click="ChooseFormType('NonProfit')" v-on:mouseover="HoverNonProfit('enter')" v-on:mouseleave="HoverNonProfit('leave')" class="btn u-shadow-v39 g-color-white g-color-white--hover g-bg-main g-bg-primary--hover g-font-size-18--md g-font-size-17 g-rounded-30 g-px-35 g-py-8">Sign Up</a>
    </article>
    <!-- End Non-Profit Div -->
  </div>

  <div class="account-section-divider"></div>
  <div class="row g-py-30 g-px-30">
    <!-- Heading -->
      <div class="g-max-width-645 text-center mx-auto mb-3">
        <h3 class="h3">Not sure which account to choose?</h3>
        <p class="g-font-size-20--md g-font-size-18">Hover your mouse over the icons and read the additional descriptions.</p>
      </div>
      <ul class="g-font-size-20--md g-font-size-16">
        <li>If you are an individual eye doctor who owns their own solo practice, it is recommended that you select a business account.</li>
        <li>You can be a part of a Practice/Business Account and still sign up for an Individual Account for all your private charitable work.</li>
        <li>Orders are routed through the OneSight EssilorLuxottica Foundation lab(s) and may not be completed by an existing lab relationship.</li>
      </ul>
    <!-- End Heading -->
  </div>
   <div class="account-section-divider"></div>
</div>
</template>

<script>
export default {
  data() {
    return {
      individualIcon: '../../../static/assets/img/Registration/optometrist_inv.png',
      practiceIcon: '../../../static/assets/img/Registration/practice_acc_inv.png',
      nonProfitIcon: '../../../static/assets/img/Registration/nonprofit_acc_inv.png'
    }
  },
  methods: {
    ChooseFormType(formType){
        this.$router.push({name: 'Registration', params: {type:formType}});
        this.$emit("clicked");
    },
    HoverIndividual(event) {
      if(event == 'enter'){
        this.individualIcon = '../../../static/assets/img/Registration/optometrist.png';
      }
      else if(event == 'leave'){
        this.individualIcon = '../../../static/assets/img/Registration/optometrist_inv.png';
      }
    },
    HoverPractice(event) {
      if(event == 'enter'){
        this.practiceIcon = '../../../static/assets/img/Registration/practice_acc.png';
      }
      else if(event == 'leave'){
        this.practiceIcon = '../../../static/assets/img/Registration/practice_acc_inv.png';
      }
    },
    HoverNonProfit(event) {
      if(event == 'enter'){
        this.nonProfitIcon = '../../../static/assets/img/Registration/nonprofit_acc.png';
      }
      else if(event == 'leave'){
        this.nonProfitIcon = '../../../static/assets/img/Registration/nonprofit_acc_inv.png';
      }
    }
  }
}
</script>







// WEBPACK FOOTER //
// AccountType.vue?5aa2015a